// Book.vue
// (Родительский элемент) Площадка для отображения подробной информации из PetDetails.vue
<template>
  <v-container grid-list-md >
    <v-layout row wrap>
      <v-flex xs12 sm10 offset-sm1> 
        <create-news-details ></create-news-details>
      </v-flex>
      <v-flex xs12 sm10 offset-sm1> 
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import DeletePetDetales  from '../components/DeletePetDetales'
import CreateNewsDetails from '../components/CreateNewsDetails.vue'
export default {
  components: {
    CreateNewsDetails
    }
}
</script>

<style>

</style>